import { DEFAULT_STATE, TYPE_SEARCH } from '@/modules/sale/constants';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const state = {
  ...DEFAULT_STATE,
  list: {
    items: []
  },
  moreProductList: {
    items: []
  },
  getProductStatus: '',
  listProduct: '',
  listCache: '',
  item: null,
  isLoadMore: false,
  search: {
    mainCategoryId: '',
    isIncludeTotalCount: true,
    isIncludePurchaseHistory: true,
    hasPrice: false,
    categories: [],
    limit: 10,
    sortBy: '',
    sortType: '',
    searchQueries: '',
    offset: 0,
    isSample: false,
    productTypeId: 1,
    productAttributeValues: []
  },
  searchMore: {
    mainCategoryId: '',
    isIncludeTotalCount: true,
    isIncludePurchaseHistory: false,
    hasPrice: false,
    categories: [],
    limit: 10,
    sortBy: '',
    sortType: '',
    searchQueries: '',
    offset: 0,
    isSample: false,
    productTypeId: 1,
    productAttributeValues: []
  },
  saleUpdatePrice: [],
  CachesaleUpdatePrice: [],
  isChangeAllCategory: 1,
  type: TYPE_SEARCH.CATEGORY,
  productIdAfterExplore: null,
  listOosProduct: {
    data: []
  },
  filterAttributesSales: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
